import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? '✅ Set' : '❌ Missing');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Set' : '❌ Missing');
  throw new Error(
    'Supabase configuration error. Please ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in environment variables.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'broker-platform',
    },
  },
  db: {
    schema: 'public',
  },
  retry: {
    maxAttempts: 3,
    retryDelay: 1000,
  },
});

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          email: string | null;
          phone: string | null;
          role: 'user' | 'admin';
          balance: number;
          kyc_status: 'pending' | 'approved' | 'rejected';
          currency: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email?: string | null;
          phone?: string | null;
          role?: 'user' | 'admin';
          balance?: number;
          kyc_status?: 'pending' | 'approved' | 'rejected';
          currency?: string;
        };
        Update: {
          balance?: number;
          kyc_status?: 'pending' | 'approved' | 'rejected';
          role?: 'user' | 'admin';
          currency?: string;
        };
      };
      transactions: {
        Row: {
          id: string;
          user_id: string;
          type: 'deposit' | 'withdrawal' | 'admin_adjustment';
          amount: number;
          status: 'pending' | 'approved' | 'rejected' | 'completed';
          admin_note: string | null;
          currency: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          user_id: string;
          type: 'deposit' | 'withdrawal' | 'admin_adjustment';
          amount: number;
          status?: 'pending' | 'approved' | 'rejected' | 'completed';
          admin_note?: string | null;
          currency?: string;
        };
        Update: {
          status?: 'pending' | 'approved' | 'rejected' | 'completed';
          admin_note?: string | null;
          currency?: string;
        };
      };
      kyc_documents: {
        Row: {
          id: string;
          user_id: string;
          doc_type: 'id_card' | 'selfie' | 'address_proof';
          file_url: string;
          status: 'pending' | 'approved' | 'rejected';
          admin_note: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          user_id: string;
          doc_type: 'id_card' | 'selfie' | 'address_proof';
          file_url: string;
          status?: 'pending' | 'approved' | 'rejected';
        };
        Update: {
          status?: 'pending' | 'approved' | 'rejected';
          admin_note?: string | null;
        };
      };
      chat_messages: {
        Row: {
          id: string;
          user_id: string;
          sender_role: 'user' | 'admin';
          message: string;
          is_read: boolean;
          created_at: string;
        };
        Insert: {
          user_id: string;
          sender_role: 'user' | 'admin';
          message: string;
          is_read?: boolean;
        };
        Update: {
          is_read?: boolean;
        };
      };
    };
  };
};